// extracted by mini-css-extract-plugin
export var deleteIcon = "_qv-5";
export var deleteOption = "_qv-3";
export var divider = "_qv-2";
export var downloadIcon = "_qv-4";
export var drawer = "_qv-0";
export var drawerFooter = "_qv-6";
export var drawerOpen = "_qv-1";
export var highlighted = "_qv-7";
export var lighterHighlight = "_qv-8";